__webpack_require__.p = "/sendbird-live-sample-video-react/";